/**
 * テナント自身の運搬・処分事業者
 */
import Vue from 'vue'
import * as httpConst from '../../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/search/tenants/traders`

const search_tenant_trader = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    index ({commit}, { conditions = {} }) {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: conditions }).then(data => {
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
}
export default search_tenant_trader
